import { Suspense } from "react";
import { LoadingIndicator } from "components";
import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { PersonnummerPrompt } from "components/PersonnummerPrompt/PersonnummerPrompt";
import { Outlet } from "react-router-dom";

export const MainLayout = () => {
  return (
    <div className="box-border text-primary-100 bg-ghost-white-100 min-h-[calc(100vh-0.5rem)]">
      <ErrorBoundary>
        <PersonnummerPrompt />
        <Suspense fallback={<LoadingIndicator center />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};
